import React from 'react';
import ReactDOM from 'react-dom';
import 'opensans-npm-webfont';
import Cookie from 'js-cookie';
import Raven from 'raven-js';
import './styles/app.css';
import './styles/buttons.css';
import './styles/inputs.css';
import './styles/tooltip.css';
import App from './components/app';
import './index.css';


// COOKIES SET UP
// =================================================================================================
let createUniId = function() {
	return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function( c ) {
		return ( c ^ ( window.crypto || window.msCrypto ).getRandomValues( new Uint8Array(1))[0] & 15 >> c / 4 ).toString( 16 );
	});
};

if ( !Cookie.get( 'userId' ) ) Cookie.set( 'userId', createUniId() );


// SET LANGUAGE
// =================================================================================================
let lang = navigator.language || navigator.userLanguage;

window.userLanguage = localStorage.getItem( 'userLanguage' ) || ( lang.indexOf( 'en' ) > -1 ? 'EN' : 'CN' );


// MIXPANEL SETUP & TRACKING SETUP
// =================================================================================================
require( 'mixpanel-browser' );

window.mixpanel.init( '1d43ec5cfdfedd640249930fc2383873' );

window.trackEvent = function( action, params ) {

	params.userId = Cookie.get( 'userId' );

	window.mixpanel.track( action, params );

	params.action = action;

	ga( 'send', params )
};

// INIT REACT APP
// =================================================================================================
ReactDOM.render( <App />, document.getElementById( 'root' ) );

// START TRACKING ERRORS WITH SENTRY
Raven.config( 'https://c104cdb9b0fa4fc1bae1c4c02181d510@sentry.io/633112' ).install();



// WEBPACK FOOTER //
// ./src/index.js